import "./index.pcss";

$(".alert")
  .delay(1500)
  .slideUp(500);
